// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"vMUDXTG","sellerDetails":"vMUDXTG","seller-name":"sEp7N9t","sellerName":"sEp7N9t","badge":"EkG4AmC","promoted-gig-text":"QzcfBFf","promotedGigText":"QzcfBFf"};